import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { isBrowser } from 'Helpers/Browser';
import { getSearch } from 'Helpers/Uri';
import { getLastPage } from 'Helpers/Pagination';

export default class Pagination extends React.Component {
    static propTypes = {
        onPageChange: PropTypes.func,
        totalElements: PropTypes.number,
        elementsPerPage: PropTypes.number,
        link: PropTypes.string,
        currentPage: PropTypes.number,
    };
    static defaultProps = {
        onPageChange: () => false,
        totalElements: 0,
        elementsPerPage: 40,
        currentPage: 1
    }

    constructor(props) {
        super(props);

        this.state = {
            pagesVisibleCount: 10
        };
    }

    handleResize = () => {
        let pagesVisibleCount = this.state.pagesVisibleCount;
        switch (true) {
            case this.container.clientWidth > 1600:
                pagesVisibleCount = 16;
                break;
            case this.container.clientWidth <= 1600 && this.container.clientWidth > 1200:
                pagesVisibleCount = 12;
                break;
            case this.container.clientWidth <= 1200 && this.container.clientWidth > 768:
                pagesVisibleCount = 10;
                break;
            case this.container.clientWidth <= 768 && this.container.clientWidth > 480:
                pagesVisibleCount = 8;
                break;
            case this.container.clientWidth <= 480:
                pagesVisibleCount = 6;
                break;
        }

        this.setState({
            ...this.state,
            pagesVisibleCount: pagesVisibleCount,
            containerWidth: this.container.clientWidth
        });
    }

    getLink = page => {
        if (!this.props.link) {
            return null;
        }

        let parsedLink = this.props.link.replace('%pageNumber%', page);
        parsedLink = parsedLink.endsWith('/page-1') ? parsedLink.replace('/page-1', '') : parsedLink;

        return encodeURI(parsedLink) + getSearch();
    }

    renderPagination = () => {
        let { totalElements, elementsPerPage, currentPage } = this.props;
        let { pagesVisibleCount } = this.state;

        // totalElements = totalElements <= 20000 ? totalElements : 20000; //Elastic search max records fix
        let lastPage = getLastPage(totalElements, elementsPerPage);
        let pagination = [];

        if (lastPage < 2) {
            return null;
        }

        //Prevoius page
        if (currentPage > 1) {
            pagination.push(
                <Link
                    key="page-prev"
                    to={this.getLink(currentPage - 1)}
                    onClick={() => this.props.onPageChange(currentPage - 1)}
                    className="pagination-element pagination-element-prev"
                    rel="prev"
                >
                    <i className="fa fa-chevron-left"></i>
                </Link>);
        }

        //Pages before current
        let pageBeforeCount = 0;
        if (currentPage < Math.ceil(pagesVisibleCount / 2)) {
            pageBeforeCount = currentPage - 1;
        } else {
            pageBeforeCount = Math.ceil(pagesVisibleCount / 2);
        }


        if (pageBeforeCount > 0) {
            for (let i = pageBeforeCount; i >= 0; i--) {
                let pageNumber = currentPage - i;
                if (pageNumber !== currentPage && pageNumber > 0) {
                    pagination.push(
                        <Link
                            key={'page-' + pageNumber}
                            to={this.getLink(pageNumber)}
                            onClick={() => this.props.onPageChange(pageNumber)}
                            className="pagination-element"
                        >
                            {pageNumber}
                        </Link>
                    );
                }
            }
        }

        //Current page
        pagination.push(
            <Link
                key={'page-current'}
                className="pagination-element active"
            >
                {currentPage}
            </Link>
        );

        // //Pages after current
        let pageAfterCount = pagesVisibleCount - pageBeforeCount;
        for (let i = 0; i < pageAfterCount; i++) {
            let pageNumber = currentPage + i;

            if (pageNumber <= lastPage && pageNumber !== currentPage) {
                pagination.push(
                    <Link
                        key={'page-' + pageNumber}
                        to={this.getLink(pageNumber)}
                        onClick={() => this.props.onPageChange(pageNumber)}
                        className="pagination-element"
                    >
                        {pageNumber}
                    </Link>
                );
            }
        }

        //Next page
        if (currentPage < lastPage) {
            pagination.push(
                <Link
                    rel="next"
                    key="page-next"
                    to={this.getLink(currentPage + 1)}
                    onClick={() => this.props.onPageChange(currentPage + 1)}
                    className="pagination-element pagination-element-next"
                >
                    <i className="fa fa-chevron-right"></i>
                </Link>
            );
        }

        return pagination;
    }

    render() {
        return (
            <div className="component-pagination" ref={node => this.container = node}>
                <div className="pagination-list">
                    {this.renderPagination()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Pagination/index.js